/**
 * Fileter array of object by propery value
 * 1. array - delivered array with date property
 * 2. filters - Array of results
 * 3. filterProperty - property of object that we want to filter
 */
export default (array, filters, objectProperty) => {
  if (!filters || !filters.length) {
    return array;
  }

  const filteredArray = array.filter((item) => filters.includes(item[objectProperty]));

  return filteredArray;
};
